import overSome from "lodash/overSome";

const _ = { overSome };

export const showContact = poi => (poi.website || poi.email || poi.telephone);
export const showMap = poi =>
  (poi.address && poi.address.street) ||
  (poi.location && poi.location.coordinates);

export const showGroupSize = poi => poi.groupSize &&
  Object.keys(poi.groupSize).length > 0 &&
  poi.groupSize.description;

export const showConvenience = poi => poi.poiType === "sleeping" &&
  poi.providers &&
  (poi.providers[0].facilities.indexOf("free wifi") > -1 ||
  poi.providers[0].facilities.indexOf("late checkout") > -1 ||
  poi.providers[0].facilities.indexOf("private parking") > -1 ||
  !!poi.containingPlace.ancestry);

export const showDuration = poi => poi.duration && Object.keys(poi.duration).length > 0;
export const showDepartureReturn = poi => poi.departureInfo && poi.returnInfo;
export const showPrice = poi => poi.priceString;
export const showHours = poi => poi.hoursString;

export const showRating = poi => {
  const provider = poi.providers || poi.provider;
  return (provider && provider[0].score > 0 && provider[0].score <= 10) ||
    (provider && poi.rating > 0);
};

const show = _.overSome([
  showContact,
  showMap,
  showGroupSize,
  showConvenience,
  showDuration,
  showDepartureReturn,
  showPrice,
  showHours,
  showRating,
]);


export default function hasSidebar(poi) {
  return show(poi);
}



// WEBPACK FOOTER //
// ./assets/pois/utils/hasSidebar.js